import {
  LoadAllSuccess,
  LoadManySuccess,
  CreateSuccess,
  UpdateSuccess,
  DeleteSuccess,
  UpsertManySuccess,
  DeleteManyByKeysSuccess,
} from '@briebug/ngrx-auto-entity';
import { catchError, concatMap, exhaustMap, map } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';
import { ToastController } from '@ionic/angular';
import { AppState } from './app.state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { createAction, props, Store } from '@ngrx/store';
import {
  EmergencyTicketService,
  CreateEmergencyTicketPayload,
  CreateEmergencyCrewRequest,
  UpdateEmergencyTicketPayload,
  DeleteEmergencyCrewRequest,
  DeleteEmergencyTicketPayload,
  EmergencyTicketMutationResponse,
  ExtendEmergencyRequest,
  AddEmergencyCrewRequest,
  AddEmergencyEquipRequest,
  DeleteEmergencyDayRequest,
  DeleteEmergencyCrewOnDayRequest,
  TrimEmergencyEquipRequest,
} from '@services/api/emergency-ticket.service';
import {
  EmergencyTicket,
  Job,
  JobPlan,
  JobLocate,
  JobPlanCrewRequirement,
  JobPlanCrewAssignment,
  Crew,
  JobPlanEquipReq,
} from '@app/models';

export const loadEmergencyTickets = createAction('[Emergency Tickets] Load');
export const loadEmergencyTicketsPlanner = createAction(
  '[Emergency Tickets] Load Planner'
);

export const createEmergencyTicket = createAction(
  '[Emergency Tickets] Create',
  props<{ payload: CreateEmergencyTicketPayload }>()
);

export const createEmergencyCrew = createAction(
  '[Emergency Tickets] Create Crew',
  props<{ payload: CreateEmergencyCrewRequest }>()
);

export const deleteEmergencyCrew = createAction(
  '[Emergency Tickets] Delete Crew',
  props<{ payload: DeleteEmergencyCrewRequest }>()
);

export const updateEmergencyTicket = createAction(
  '[Emergency Tickets] Update Ticket',
  props<{ payload: UpdateEmergencyTicketPayload }>()
);

export const deleteEmergencyTicket = createAction(
  '[Emergency Tickets] Delete Ticket',
  props<{ payload: DeleteEmergencyTicketPayload }>()
);

export const extendEmergencyTicket = createAction(
  '[Emergency Tickets] Extend',
  props<{ payload: ExtendEmergencyRequest }>()
);

export const addEmergencyCrewOnDays = createAction(
  '[Emergency Tickets] Add Crew On Days',
  props<{ payload: AddEmergencyCrewRequest }>()
);

export const addEmergencyEquipOnDay = createAction(
  '[Emergency Tickets] Add Equipment On Day',
  props<{ payload: AddEmergencyEquipRequest }>()
);

export const deleteEmergencyDay = createAction(
  '[Emergency Tickets] Delete Day',
  props<{ payload: DeleteEmergencyDayRequest }>()
);

export const deleteEmergencyCrewOnDay = createAction(
  '[Emergency Tickets] Delete Crew On Day',
  props<{ payload: DeleteEmergencyCrewOnDayRequest }>()
);

export const trimEmergencyEquip = createAction(
  '[Emergency Tickets] Trim Equipment',
  props<{ payload: TrimEmergencyEquipRequest }>()
);

@Injectable()
export class EmergencyTicketEffects {
  loadEmergTickets$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadEmergencyTickets),
        exhaustMap(action =>
          this.emergTicketService.loadAll().pipe(
            map(response => {
              this.store$.dispatch(
                new LoadAllSuccess(EmergencyTicket, response.emergencyTickets)
              );
              this.store$.dispatch(new LoadManySuccess(Job, response.jobs));
              this.store$.dispatch(
                new LoadManySuccess(JobPlan, response.jobPlans)
              );
              this.store$.dispatch(
                new LoadManySuccess(JobLocate, response.locates)
              );
              this.store$.dispatch(
                new LoadAllSuccess(
                  JobPlanCrewRequirement,
                  response.crewRequirements
                )
              );
              this.store$.dispatch(
                new LoadAllSuccess(
                  JobPlanCrewAssignment,
                  response.crewAssignments
                )
              );
              this.store$.dispatch(new LoadManySuccess(Crew, response.crews));
              this.store$.dispatch(
                new LoadManySuccess(JobPlanEquipReq, response.equipRequirements)
              );
            })
            // catchError(error => {
            //   console.log(error);
            // })
          )
        )
      ),
    { dispatch: false }
  );

  loadPlannerEmergTickets$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadEmergencyTicketsPlanner),
        exhaustMap(action =>
          this.emergTicketService.loadPlanner().pipe(
            map(response => {
              this.store$.dispatch(
                new LoadAllSuccess(EmergencyTicket, response.emergencyTickets)
              );
              this.store$.dispatch(new LoadManySuccess(Job, response.jobs));
              this.store$.dispatch(
                new LoadManySuccess(JobPlan, response.jobPlans)
              );
            })
            // catchError(error => {
            //   console.log(error);
            // })
          )
        )
      ),
    { dispatch: false }
  );

  createEmergTickets$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createEmergencyTicket),
        exhaustMap(action =>
          this.emergTicketService.createTicket(action.payload).pipe(
            map(response => {
              this.store$.dispatch(
                new CreateSuccess(EmergencyTicket, response.emergencyTicket)
              );
              this.store$.dispatch(new CreateSuccess(Job, response.job));
              this.store$.dispatch(
                new CreateSuccess(JobPlan, response.jobPlan)
              );
            })
            // catchError(error => {
            //   console.log(error);
            // })
          )
        )
      ),
    { dispatch: false }
  );

  deleteEmergTicket$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteEmergencyTicket),
        exhaustMap(action =>
          this.emergTicketService.deleteTicket(action.payload).pipe(
            map(response => {
              this.store$.dispatch(
                new DeleteSuccess(
                  EmergencyTicket,
                  action.payload.emergencyTicket
                )
              );
              this.store$.dispatch(
                new DeleteSuccess(JobPlan, action.payload.jobPlan)
              );
              this.store$.dispatch(new DeleteSuccess(Job, action.payload.job));
            })
            // catchError(error => {
            //   console.log(error);
            // })
          )
        )
      ),
    { dispatch: false }
  );

  deleteEmergCrew$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteEmergencyCrew),
        exhaustMap(action =>
          this.emergTicketService.deleteCrew(action.payload).pipe(
            map(response => {
              this.store$.dispatch(
                new DeleteSuccess(
                  JobPlanCrewAssignment,
                  action.payload.crewAssignment
                )
              );
              this.store$.dispatch(
                new DeleteSuccess(
                  JobPlanCrewRequirement,
                  action.payload.crewRequirement
                )
              );
            })
            // catchError(error => {
            //   console.log(error);
            // })
          )
        )
      ),
    { dispatch: false }
  );

  updateEmergTickets$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateEmergencyTicket),
        concatMap(action =>
          this.applyMutation(
            this.emergTicketService.updateTicket(action.payload)
          )
        )
      ),
    { dispatch: false }
  );

  extendEmergTicket$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(extendEmergencyTicket),
        concatMap(action =>
          this.applyMutation(this.emergTicketService.extend(action.payload))
        )
      ),
    { dispatch: false }
  );

  addEmergCrewOnDays$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addEmergencyCrewOnDays),
        concatMap(action =>
          this.applyMutation(
            this.emergTicketService.addCrewOnDays(action.payload)
          )
        )
      ),
    { dispatch: false }
  );

  addEmergEquipOnDay$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addEmergencyEquipOnDay),
        concatMap(action =>
          this.applyMutation(
            this.emergTicketService.addEquipmentOnDay(action.payload)
          )
        )
      ),
    { dispatch: false }
  );

  deleteEmergDay$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteEmergencyDay),
        concatMap(action =>
          this.applyMutation(this.emergTicketService.deleteDay(action.payload))
        )
      ),
    { dispatch: false }
  );

  deleteEmergCrewOnDay$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteEmergencyCrewOnDay),
        concatMap(action =>
          this.applyMutation(
            this.emergTicketService.deleteCrewOnDay(action.payload)
          )
        )
      ),
    { dispatch: false }
  );

  trimEmergEquip$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(trimEmergencyEquip),
        concatMap(action =>
          this.applyMutation(this.emergTicketService.trimEquip(action.payload))
        )
      ),
    { dispatch: false }
  );

  createEmergCrew$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createEmergencyCrew),
        exhaustMap(action =>
          this.emergTicketService.createCrew(action.payload).pipe(
            map(response => {
              this.store$.dispatch(
                new CreateSuccess(JobPlanCrewRequirement, response.crewReq)
              );
              this.store$.dispatch(
                new CreateSuccess(JobPlanCrewAssignment, response.crewAssign)
              );
              this.store$.dispatch(new CreateSuccess(Crew, response.crew));
            })
            // catchError(error => {
            //   console.log(error);
            // })
          )
        )
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private emergTicketService: EmergencyTicketService,
    private store$: Store<AppState>,
    private toastCtrl: ToastController
  ) {}

  // Every ticket mutation returns the ticket's full state plus removed ids.
  private applyMutation(request: Observable<EmergencyTicketMutationResponse>) {
    return request.pipe(
      map(response => this.applyTicketResponse(response)),
      catchError(error => {
        // The API interceptor rethrows only 400s, which carry { error }.
        this.showError(error);
        return EMPTY;
      })
    );
  }

  private applyTicketResponse(r: EmergencyTicketMutationResponse) {
    const dispatch = (action: any) => this.store$.dispatch(action);
    dispatch(new UpsertManySuccess(EmergencyTicket, r.emergencyTickets));
    dispatch(new UpsertManySuccess(Job, r.jobs));
    dispatch(new UpsertManySuccess(JobPlan, r.jobPlans));
    dispatch(new UpsertManySuccess(JobLocate, r.locates));
    dispatch(new UpsertManySuccess(Crew, r.crews));
    dispatch(new UpsertManySuccess(JobPlanCrewRequirement, r.crewRequirements));
    dispatch(new UpsertManySuccess(JobPlanCrewAssignment, r.crewAssignments));
    dispatch(new UpsertManySuccess(JobPlanEquipReq, r.equipRequirements));
    const removed = r.removed;
    if (removed.crewAssignments.length > 0) {
      dispatch(
        new DeleteManyByKeysSuccess(
          JobPlanCrewAssignment,
          removed.crewAssignments
        )
      );
    }
    if (removed.crewRequirements.length > 0) {
      dispatch(
        new DeleteManyByKeysSuccess(
          JobPlanCrewRequirement,
          removed.crewRequirements
        )
      );
    }
    if (removed.equipRequirements.length > 0) {
      dispatch(
        new DeleteManyByKeysSuccess(JobPlanEquipReq, removed.equipRequirements)
      );
    }
  }

  private async showError(error: any) {
    const message =
      error && error.error && error.error.error
        ? error.error.error
        : 'Something went wrong. Please try again.';
    const toast = await this.toastCtrl.create({
      message,
      duration: 4000,
      color: 'danger',
    });
    await toast.present();
  }
}
